import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '战污染·赞生态';
const baseUrl = 'STZT0228';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/news`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'news',
      name: `${baseUrl}-news`,
      component: () => import('./pages/News.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
